import '@/lib/typedef';
import client from '@/lib/http-client';

const host = process.env.VUE_APP_API_FUNNEL_URL || 'https://funnel.orderonline.id';

const endpointStats = `${host}/stats`;
const endpointFunnel = `${host}/funnels`;
const endpointFunnelPages = `${host}/funnel-pages`;
const endpointPageTemplate = `${host}/page-template`;
const endpointPageEvents = `${host}/page-events`;

export default {
	getFunnels(params, cb, errorCb) {
		const url = endpointFunnel;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getFunnelDetail(id, cb, errorCb) {
		const url = `${endpointFunnel}/${id}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	createFunnel(params, cb, errorCb) {
		const url = endpointFunnel;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateFunnel(id, params, cb, errorCb) {
		const url = `${endpointFunnel}/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	deleteFunnel(id, cb, errorCb) {
		const url = `${endpointFunnel}/${id}`;
		client.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Check Funnel Slug
	 *
	 * @param {Object} params
	 * @param {slug} params.slug Slug string
	 * @param {user_id} params.user_id User ID string
	 * @param {requestCallback} cb // 200 slug available
	 * @param {errorCallback} errorCb // 400 not available
	 */
	checkFunnelSlug(params, cb, errorCb) {
		const url = `${endpointFunnel}/slug_checker`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/**
	 * Bulk Delete Contacts
	 *
	 * @param {Object} params
	 * @param {string[]} params.id Array of Funnel ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	bulkDelete(ids = [], cb, errorCb) {
		const url = `${endpointFunnel}/bulk_delete`;

		const idsJSON = JSON.stringify(ids);
		const params = {
			ids: idsJSON,
		};

		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	getPages(params, cb, errorCb) {
		const url = endpointFunnelPages;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getPageDetail(id, cb, errorCb) {
		const url = `${endpointFunnelPages}/${id}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	createPage(params, cb, errorCb) {
		const url = endpointFunnelPages;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Delete Contacts
	 *
	 * @param {Object} params
	 * @param {string[]} params.id Array of Funnel ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	bulkDeletePage(ids = [], cb, errorCb) {
		const url = `${endpointFunnelPages}/bulk_delete`;

		const idsJSON = JSON.stringify(ids);
		const params = {
			ids: idsJSON,
		};

		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	updatePage(id, params, cb, errorCb) {
		const url = `${endpointFunnelPages}/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/**
	 * Check Funnel Slug
	 *
	 * @param {Object} params
	 * @param {slug} params.slug Slug string
	 * @param {user_id} params.user_id User ID string
	 * @param {requestCallback} cb // 200 slug available
	 * @param {errorCallback} errorCb // 400 not available
	 */
	checkPageSlug(params, cb, errorCb) {
		const url = `${endpointFunnelPages}/slug_checker`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	saveTemplate(params, cb, errorCb) {
		const url = endpointPageTemplate;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getTemplates(params, cb, errorCb) {
		const url = endpointPageTemplate;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	deleteTemplate(id, cb, errorCb) {
		const url = `${endpointPageTemplate}/${id}`;
		client.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Page Visitor
	getPageVisitor(params, cb, errorCb) {
		const url = `${endpointStats}/visitor`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Stats Meta
	getStatsMeta(params, cb, errorCb) {
		const url = `${endpointStats}/meta`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Sections Stats
	 *
	 * @param {Object} params Params
	 * @param {string} params.since // Since (Date String)
	 * @param {string} params.until // Until (Date String)
	 * @param {string} params.funnel_id // Funnel ID (Optional)
	 * @param {string} params.page_id // Page ID (Optional)
	 * @param {requestCallback} [cb] // 200 slug available
	 * @param {errorCallback} [errorCb] // 400 not available
	*/
	getStatsSections(params, cb, errorCb) {
		const url = `${endpointStats}/sections`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Sections Stats
	 *
	 * @param {Object} params Params
	 * @param {string} params.since // Since (Date String)
	 * @param {string} params.until // Until (Date String)
	 * @param {string} params.funnel_id // Funnel ID (Optional)
	 * @param {string} params.page_id // Page ID (Optional)
	 * @param {string} [params.type=click] // Type: click (Optional)
	 * @param {string[]} params.ids // Array of Element ID (Optional)
	 * @param {string[]} params.classess // Array of Element Classess (Optional)
	 * @param {requestCallback} [cb] // 200 slug available
	 * @param {errorCallback} [errorCb] // 400 not available
	*/
	getPageEvents(params, cb, errorCb) {
		const url = `${endpointPageEvents}/total`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Duplicate Funnels
	 *
	 * @param {Object} params Params
	 * @param {string[]} params.ids // Array of Element ID (Optional)
	 * @param {requestCallback} [cb] // 200 slug available
	 * @param {errorCallback} [errorCb] // 400 not available
	*/
	duplicateFunnels(params, cb, errorCb) {
		const url = `${endpointFunnel}/duplicate`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Duplicate Funnel Pages
	 *
	 * @param {Object} params Params
	 * @param {string[]} params.ids // Array of Element ID (Optional)
	 * @param {requestCallback} [cb] // 200 slug available
	 * @param {errorCallback} [errorCb] // 400 not available
	*/
	duplicateFunnelPages(params, cb, errorCb) {
		const url = `${endpointFunnelPages}/duplicate`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Stats Traffic
	getStatsTraffic(params, cb, errorCb) {
		const url = `${endpointStats}/traffic`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// get order notif id
	getOrderNotifId(params, cb, errorCb) {
		const url = `${host}/order-notif`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Pages Sections
	getPagesSections(params, cb, errorCb) {
		const url = `${endpointFunnelPages}/sections`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
